"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6418],{

/***/ 64668:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64667);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63687);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25747);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96934);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29564);







const Desktop = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName () {
        return "compositions-Header-view-Desktop-Desktop";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>Promise.all(/* import() | compositions-Header-view-Desktop-Desktop */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6471), __webpack_require__.e(6102), __webpack_require__.e(7936), __webpack_require__.e(6418), __webpack_require__.e(9313), __webpack_require__.e(2236), __webpack_require__.e(182), __webpack_require__.e(8371), __webpack_require__.e(60), __webpack_require__.e(1223), __webpack_require__.e(8101), __webpack_require__.e(5742), __webpack_require__.e(7288)]).then(__webpack_require__.bind(__webpack_require__, 44690)),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(44690);
        }
        return eval("require.resolve")("compositions/Header/view/Desktop/Desktop");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "bg-black",
        pw: 100,
        h: 64
    })
});
const Mobile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName () {
        return "compositions-Header-view-Mobile-Mobile";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>Promise.all(/* import() | compositions-Header-view-Mobile-Mobile */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6471), __webpack_require__.e(7369), __webpack_require__.e(7936), __webpack_require__.e(6418), __webpack_require__.e(9313), __webpack_require__.e(2236), __webpack_require__.e(182), __webpack_require__.e(8371), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1223), __webpack_require__.e(8101), __webpack_require__.e(5742), __webpack_require__.e(1821)]).then(__webpack_require__.bind(__webpack_require__, 11601)),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(11601);
        }
        return eval("require.resolve")("compositions/Header/view/Mobile/Mobile");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "bg-black",
        pw: 100,
        h: 48
    })
});
const Header = (props)=>{
    const { withBanner, withSubHeader, withSupNav, withQueueCounter, loginWithBackRedirect, logoLink } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const isChatAssistanceEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.features.budgieChatAssistance);
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mobile, {
            withBanner: withBanner,
            withSubHeader: withSubHeader,
            logoLink: logoLink,
            withQueueCounter: withQueueCounter,
            loginWithBackRedirect: loginWithBackRedirect
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Desktop, {
        withBanner: withBanner,
        withSupNav: withSupNav,
        logoLink: logoLink,
        withQueueCounter: withQueueCounter,
        loginWithBackRedirect: loginWithBackRedirect,
        withChatAssistance: isChatAssistanceEnabled
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Header);


/***/ }),

/***/ 82271:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Banner_Banner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/banners/SubscribeHeaderBanner/SubscribeHeaderBanner.tsx + 1 modules
var SubscribeHeaderBanner = __webpack_require__(64792);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@growthbook+growthbook-react@0.23.0_react@18.2.0/node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(26853);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/hooks/useExpiration.ts
var useExpiration = __webpack_require__(38898);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(64667);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(36888);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(88852);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(29703);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/util/useBanner.ts









const normalizePagePaths = (pagePaths)=>{
    return pagePaths.map((link)=>link.replace("(.*)", "").replace(":slug", "")).join("|");
};
const productPagePaths = normalizePagePaths([
    links/* default */.ZP.productGeneral,
    links/* default */.ZP.productCandle,
    links/* default */.ZP.productExtra,
    links/* default */.ZP.productMakeup,
    links/* default */.ZP.productPerfume,
    links/* default */.ZP.productPerfumeLanding,
    links/* default */.ZP.productPersonalCare,
    links/* default */.ZP.productSkincare,
    links/* default */.ZP.productWellness,
    links/* default */.ZP.productDiffuser,
    links/* default */.ZP.productAccessory
]);
const productPagePathRegExp = new RegExp(`^(${productPagePaths})`);
const useBanner = ()=>{
    const pathname = (0,hooks/* usePathname */.jD)();
    const { isLoggedIn, isFetching: isUserFetching } = (0,user/* useUser */.aF)();
    const { subscription, isFetching: isSubscriptionFetching } = (0,subscription_subscription/* useSubscription */.mU)();
    const { privateSale, isFetching: isPrivateSaleFetching } = (0,usePrivateSale/* default */.Z)();
    const { candleSubscription, isFetching: isCandleSubscriptionFetching } = (0,subscriptionAddons/* useCandleSubscription */.pj)();
    const { driftSubscription } = (0,subscriptionAddons/* useDriftSubscription */.RD)();
    const isGiftHubEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHub);
    const isHolidayMothersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayMothersDay);
    const isHolidayFathersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayFathersDay);
    const isGiftHubHeaderBannerEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.giftHubHeaderBanner);
    const isHeaderBannerVisibleOnGiftHubEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.headerBannerVisibleOnGiftHub);
    const holidayBannerDiscountValue = (0,esm/* useFeatureValue */.aS)(constants/* default */.Z.features.holidayBanner, 0);
    const isBlackFridayBannerEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.blackFridayTopHomePageBanner);
    const isCyberMondayBannerEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.cyberMondayTopHomePageBanner);
    const isDriftSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscription);
    const isDriftSubscriptionLaunchPromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscriptionLaunchPromo);
    const isBfcmNotificationEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.bfcmNotification);
    const isGiftSubscriptionNotificationEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.giftSubscriptionNotification);
    const isGwpTopBarVisible = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.gwpTopBar);
    const isFetching = isUserFetching || isSubscriptionFetching || isPrivateSaleFetching || isCandleSubscriptionFetching;
    const isSubscribeBannerVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && pathname !== links/* default */.ZP.subscription.main && !productPagePathRegExp.test(pathname);
    // show banner only when subscription is in undeliverable status
    const isUndeliverableBannerVisible = subscription === null || subscription === void 0 ? void 0 : subscription.isUndeliverable;
    const isCardUpdateBannerVisible = subscription === null || subscription === void 0 ? void 0 : subscription.isUnpaid;
    const isTossInBannerVisible = isLoggedIn && pathname !== links/* default */.ZP.tossIn && (subscription === null || subscription === void 0 ? void 0 : subscription.canApplyTossInOffer);
    const holidayBannerDiscount = pathname !== links/* default */.ZP.shop.holiday ? holidayBannerDiscountValue : 0;
    const isBfcmBannerVisible = isBfcmNotificationEnabled && pathname === links/* default */.ZP.shop.holiday;
    const isGiftSubscriptionBannerVisible = isGiftSubscriptionNotificationEnabled && pathname === links/* default */.ZP.giftSubscription;
    const isHolidayBannerVisible = isGiftHubEnabled && (pathname !== links/* default */.ZP.gifts ? isGiftHubHeaderBannerEnabled : isHeaderBannerVisibleOnGiftHubEnabled) && !isHolidayMothersDayEnabled && !isHolidayFathersDayEnabled && !isBfcmBannerVisible && !isGiftSubscriptionBannerVisible;
    const isHolidayMothersDayVisible = isGiftHubEnabled && isGiftHubHeaderBannerEnabled && isHolidayMothersDayEnabled && pathname !== links/* default */.ZP.gifts;
    const isHolidayFathersDayVisible = isGiftHubEnabled && isGiftHubHeaderBannerEnabled && isHolidayFathersDayEnabled && pathname !== links/* default */.ZP.gifts;
    const isBlackFridayBannerVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && isBlackFridayBannerEnabled && (pathname === links/* default */.ZP.home || pathname === links/* default */.ZP.homeMen);
    const isCyberMondayBannerVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && isCyberMondayBannerEnabled && (pathname === links/* default */.ZP.home || pathname === links/* default */.ZP.homeMen);
    const isPrivateSaleExpired = (0,useExpiration/* default */.Z)({
        timeLeft: privateSale === null || privateSale === void 0 ? void 0 : privateSale.timeLeft
    });
    const isPrivateSaleBannerVisible = isLoggedIn && pathname !== links/* default */.ZP.privateSale && Boolean(privateSale) && !isPrivateSaleExpired;
    const isUnskipBannerVisible = isLoggedIn && (subscription === null || subscription === void 0 ? void 0 : subscription.isOnHold) && Boolean(subscription === null || subscription === void 0 ? void 0 : subscription.activeHold);
    const isCandleSubscriptionBannerVisible = (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected) && pathname !== links/* default */.ZP.candleSubscription && pathname !== links/* default */.ZP.featuredCandle;
    const isDriftSubscriptionVisible = isDriftSubscriptionEnabled && (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled) && !(driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected) && pathname !== links/* default */.ZP.driftSubscription;
    const isDriftSubscriptionHasLaunchPriority = isDriftSubscriptionLaunchPromoEnabled;
    const isResubscribeBannerVisible = Boolean(subscription === null || subscription === void 0 ? void 0 : subscription.isCancelled);
    return {
        isFetching,
        isCardUpdateBannerVisible,
        isSubscribeBannerVisible,
        isUndeliverableBannerVisible,
        isTossInBannerVisible,
        isPrivateSaleBannerVisible,
        isUnskipBannerVisible,
        isCandleSubscriptionBannerVisible,
        isHolidayBannerVisible,
        holidayBannerDiscount,
        isHolidayMothersDayVisible,
        isHolidayFathersDayVisible,
        isBlackFridayBannerVisible,
        isCyberMondayBannerVisible,
        isResubscribeBannerVisible,
        isDriftSubscriptionVisible,
        isDriftSubscriptionHasLaunchPriority,
        isBfcmBannerVisible,
        isGiftSubscriptionBannerVisible,
        isGwpTopBarVisible
    };
};
/* harmony default export */ const util_useBanner = (useBanner);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(30468);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx + 1 modules
var HeaderBannerContainer = __webpack_require__(12769);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CardUpdateBanner/messages.ts
/* harmony default export */ const CardUpdateBanner_messages = ({
    text: {
        en: `Your card was declined, <br class="onlyMobile" />please update your payment info`
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CardUpdateBanner/CardUpdateBanner.tsx









const CardUpdateBanner = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: "sticky top-0 z-floating-header bg-red",
        height: 64,
        to: links/* default */.ZP.cardUpdate,
        trackParams: {
            placement: "Header",
            content: "Payment method update",
            action: "link",
            link: links/* default */.ZP.cardUpdate
        },
        "data-testid": "headerCardUpdateBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex  items-center", isMobile ? "justify-between" : "justify-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: CardUpdateBanner_messages.text,
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "ml-24 flex-none",
                    title: messages/* default */.Z.update,
                    size: 38,
                    tabIndex: -1
                })
            ]
        })
    });
};
/* harmony default export */ const CardUpdateBanner_CardUpdateBanner = (CardUpdateBanner);

// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UndeliverableBanner/messages.ts
/* harmony default export */ const UndeliverableBanner_messages = ({
    message: {
        en: "Subscription paused, due to a wrong shipping address"
    },
    button: {
        en: "Update your shipping address"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UndeliverableBanner/UndeliverableBanner.tsx








const UndeliverableBanner = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: "bg-red",
        height: 64,
        to: links/* default */.ZP.profile.shipping,
        trackParams: {
            placement: "Header",
            content: "Undeliverable address",
            action: "link",
            link: links/* default */.ZP.profile.shipping
        },
        "data-testid": "undeliverableBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex items-center justify-center", isMobile ? "flex-col" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: UndeliverableBanner_messages.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)("flex flex-none items-center", isMobile ? "mt-4" : "ml-24"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "h7",
                            message: UndeliverableBanner_messages.button
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            className: "ml-12 flex-none",
                            name: "other/long-arrow-right"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const UndeliverableBanner_UndeliverableBanner = (UndeliverableBanner);

// EXTERNAL MODULE: ./src/components/dataDisplay/Carousel/Carousel.tsx + 2 modules
var Carousel = __webpack_require__(51039);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BannersCarousel/BannersCarousel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const BannersCarousel_module = ({"carousel":"mnJuzW"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BannersCarousel/BannersCarousel.tsx





const BannersCarousel = (props)=>{
    const { children } = props;
    // return one banner as is
    if (react.Children.count(children) <= 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        className: (0,clsx/* default */.Z)("relative overflow-hidden", BannersCarousel_module.carousel),
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        rewind: true,
        withDots: true,
        children: react.Children.map(children, (child, index)=>{
            if (!/*#__PURE__*/ (0,react.isValidElement)(child)) {
                return child;
            }
            return /*#__PURE__*/ react.cloneElement(child, {
                className: "pb-12",
                position: index + 1
            });
        })
    });
};
/* harmony default export */ const BannersCarousel_BannersCarousel = (BannersCarousel);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BannerBase/BannerBase.tsx






const BannerBase = (props)=>{
    const { className, title, titleStyle = "h8", height: customHeight, to, loading, html, trackParams, onClick, "data-testid": dataTestId } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const height = customHeight || (isMobile ? 48 : 56);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBannerContainer/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "bg-gold-50"),
        to: to,
        height: height,
        loading: loading,
        trackParams: trackParams,
        onClick: onClick,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: titleStyle,
                message: title,
                html: html
            }),
            Boolean(to) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-12 flex-none",
                name: "other/long-arrow-right"
            })
        ]
    });
};
/* harmony default export */ const BannerBase_BannerBase = (BannerBase);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/TossInBanner/messages.ts
/* harmony default export */ const TossInBanner_messages = ({
    title: {
        en: "Product add-ons, at a discount"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/TossInBanner/TossInBanner.tsx






const TossInBanner = (param)=>{
    let { className, position } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: className,
        title: TossInBanner_messages.title,
        to: links/* default */.ZP.tossIn,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Toss-in",
            action: "link",
            link: links/* default */.ZP.tossIn,
            position
        },
        "data-testid": "tossInBanner"
    });
};
/* harmony default export */ const TossInBanner_TossInBanner = (TossInBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/PrivateSaleBanner/messages.ts
/* harmony default export */ const PrivateSaleBanner_messages = ({
    title: {
        en: "Limited time private sale, happening now!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/PrivateSaleBanner/PrivateSaleBanner.tsx






const PrivateSaleBanner = (param)=>{
    let { className, position } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: className,
        title: PrivateSaleBanner_messages.title,
        titleStyle: isMobile ? "eye2" : undefined,
        to: links/* default */.ZP.privateSale,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Private sale",
            action: "link",
            link: links/* default */.ZP.privateSale,
            position
        },
        "data-testid": "privateSaleBanner"
    });
};
/* harmony default export */ const PrivateSaleBanner_PrivateSaleBanner = (PrivateSaleBanner);

// EXTERNAL MODULE: ./src/compositions/buttons/UnskipButton/util/useUnskipSubscription.ts + 2 modules
var useUnskipSubscription = __webpack_require__(20951);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UnskipBanner/messages.ts
/* harmony default export */ const UnskipBanner_messages = ({
    subTitle: {
        en: "Get access to over 700 designer & niche fragrances"
    },
    title: {
        en: "Cancel skipped month"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UnskipBanner/UnskipBanner.tsx








const UnskipBanner = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { handleUnskipSubscription, isSubmitting, isFetching } = (0,useUnskipSubscription/* default */.Z)({
        placement: "banner"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        height: 64,
        className: "bg-gold-50",
        loading: isFetching || isSubmitting,
        trackParams: {
            placement: "Header",
            content: "Unskip"
        },
        onClick: handleUnskipSubscription,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex items-center justify-center", isMobile ? "flex-col" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: UnskipBanner_messages.subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)("flex flex-none items-center", isMobile ? "mt-4" : "ml-24"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "h7",
                            message: UnskipBanner_messages.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            className: "ml-12 flex-none",
                            name: "other/long-arrow-right"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const UnskipBanner_UnskipBanner = (UnskipBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CandleSubscriptionBanner/messages.ts
/* harmony default export */ const CandleSubscriptionBanner_messages = ({
    title: {
        en: "Treat yourself to a new scented candle every month!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CandleSubscriptionBanner/CandleSubscriptionBanner.tsx







const CandleSubscriptionBanner = (param)=>{
    let { className, position } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: (0,clsx/* default */.Z)(className, "px-8"),
        title: CandleSubscriptionBanner_messages.title,
        titleStyle: isMobile ? "eye3" : undefined,
        to: links/* default */.ZP.candleSubscription,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Candle subscription",
            action: "link",
            link: links/* default */.ZP.candleSubscription,
            position
        },
        "data-testid": "candleSubscriptionBanner"
    });
};
/* harmony default export */ const CandleSubscriptionBanner_CandleSubscriptionBanner = (CandleSubscriptionBanner);

// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(70104);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(35838);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_ca14c8.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_845c9e.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/messages.ts
/* harmony default export */ const HolidayBaseBanner_messages = ({
    discount: {
        en: "Get {discount} off your first month"
    },
    freeTrial: {
        en: "Get your free perfume now"
    },
    freeProduct: {
        en: "Get a free product in your first order"
    },
    freeMonth: {
        en: "Get your second month for free"
    },
    noDiscountText: {
        en: "Get your first month of Scentbird for {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/HolidayBaseBanner.tsx










const textByOffer = {
    freeTrial: HolidayBaseBanner_messages.freeTrial,
    free2ndMonth: HolidayBaseBanner_messages.freeMonth,
    freeProduct: HolidayBaseBanner_messages.freeProduct,
    discount: HolidayBaseBanner_messages.discount
};
const HolidayBaseBanner = (props)=>{
    const { position, children, subtitle, to, withBgImage, "data-testid": dataTestId } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { discountText, formattedPriceWithDiscount, formattedPrice, formattedExtraShippingPrice, offerType } = (0,subscribe/* useSubscribeOffer */.Hu)();
    const price = formattedPriceWithDiscount || formattedPrice;
    const title = {
        ...textByOffer[offerType] || HolidayBaseBanner_messages.noDiscountText,
        values: {
            discount: discountText,
            price,
            extraShippingPrice: formattedExtraShippingPrice
        }
    };
    const content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex h-full flex-col items-center justify-center text-center",
        children: subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "text-cream-light",
                    message: subtitle,
                    style: "h9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-4",
                    message: title,
                    color: "white",
                    style: "h6"
                })
            ]
        }) : children
    });
    const wrapperClassName = "h-full w-full bg-dark-red";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        to: to,
        height: isMobile ? 64 : 56,
        onClick: ()=>{
            if (to) {
                (0,analytics/* track */.j)("Banner click", {
                    placement: "Header",
                    content: "Holiday season",
                    action: "link",
                    link: to,
                    position
                });
            }
        },
        "data-testid": dataTestId,
        children: withBgImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
            className: wrapperClassName,
            src: isMobile ? bg_mobile_namespaceObject : bg_desktop_namespaceObject,
            sizes: "100vw",
            children: content
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: wrapperClassName,
            children: content
        })
    });
};
/* harmony default export */ const HolidayBaseBanner_HolidayBaseBanner = (HolidayBaseBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidaySeasonBanner/util/messages.ts
/* harmony default export */ const util_messages = ({
    defaultTitle: {
        en: "It’s the holiday season!"
    },
    valentinesDayGiftHubSaleNotification: {
        en: "Get up to 60% OFF select Valentine’s Day gifts!"
    },
    valentinesDaySaleNotification: {
        en: "The best last-minute Valentine’s gift? A Scentbird subscription, of course."
    },
    title: {
        en: "{discount}% off select products"
    },
    button: {
        en: "Shop now"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidaySeasonBanner/util/useHolidaySeasonBanner.ts






const useHolidaySeasonBanner = (param)=>{
    let { discount } = param;
    const pathname = (0,hooks/* usePathname */.jD)();
    const isValentinesHeaderBannerEnabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.valentinesHeaderBanner);
    const message = (0,react.useMemo)(()=>{
        if (discount) {
            return {
                ...util_messages.title,
                values: {
                    discount
                }
            };
        }
        if (isValentinesHeaderBannerEnabled) {
            return pathname === links/* default */.ZP.gifts ? util_messages.valentinesDayGiftHubSaleNotification : util_messages.valentinesDaySaleNotification;
        }
        return util_messages.defaultTitle;
    }, [
        discount,
        isValentinesHeaderBannerEnabled,
        pathname
    ]);
    return {
        message,
        link: discount ? links/* default */.ZP.shop.holiday : links/* default */.ZP.gifts,
        withBgImage: !isValentinesHeaderBannerEnabled
    };
};
/* harmony default export */ const util_useHolidaySeasonBanner = (useHolidaySeasonBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidaySeasonBanner/HolidaySeasonBanner.tsx







const HolidaySeasonBanner = (props)=>{
    const { discount, position, "data-testid": dataTestId = "holidaySeasonBanner" } = props;
    const { link, message, withBgImage } = util_useHolidaySeasonBanner({
        discount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        position: position,
        to: link,
        withBgImage: withBgImage,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full items-center justify-center gap-16 px-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "flex-1 text-white",
                    message: message,
                    style: "h8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "px-8",
                    size: 38,
                    noPadding: true,
                    title: util_messages.button
                })
            ]
        })
    });
};
/* harmony default export */ const HolidaySeasonBanner_HolidaySeasonBanner = (HolidaySeasonBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BlackFridayBanner/messages.ts
/* harmony default export */ const BlackFridayBanner_messages = ({
    subtitle: {
        en: "black friday special"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BlackFridayBanner/BlackFridayBanner.tsx





const BlackFridayBanner = (param)=>{
    let { position } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        subtitle: BlackFridayBanner_messages.subtitle,
        to: links/* default */.ZP.subscribe,
        position: position,
        "data-testid": "blackFridayBanner"
    });
};
/* harmony default export */ const BlackFridayBanner_BlackFridayBanner = (BlackFridayBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CyberMondayBanner/messages.ts
/* harmony default export */ const CyberMondayBanner_messages = ({
    subtitle: {
        en: "cyber monday special"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CyberMondayBanner/CyberMondayBanner.tsx





const CyberMondayBanner = (param)=>{
    let { position } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        subtitle: CyberMondayBanner_messages.subtitle,
        to: links/* default */.ZP.subscribe,
        position: position,
        "data-testid": "cyberMondayBanner"
    });
};
/* harmony default export */ const CyberMondayBanner_CyberMondayBanner = (CyberMondayBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/MothersDayBanner/MothersDayBanner.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MothersDayBanner_module = ({"banner":"O54BU_"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/MothersDayBanner/messages.ts
/* harmony default export */ const MothersDayBanner_messages = ({
    title: {
        en: "Shop the mothers day gift guide"
    },
    button: {
        en: "Shop now"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/MothersDayBanner/MothersDayBanner.tsx










const HEIGHT_DESKTOP = 56;
const HEIGHT_MOBILE = 64;
const MothersDayBanner = (props)=>{
    const { position } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: MothersDayBanner_module.banner,
        to: links/* default */.ZP.gifts,
        height: isMobile ? HEIGHT_MOBILE : HEIGHT_DESKTOP,
        trackParams: {
            action: "link",
            content: "Marketing promo",
            contentDetails: "Mother’s day",
            link: links/* default */.ZP.gifts,
            placement: "Header",
            position
        },
        "data-testid": "holidayMothersDayBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex h-full items-center justify-center", isMobile ? "gap-40" : "gap-16"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: MothersDayBanner_messages.title,
                    color: "white",
                    style: isMobile ? "h9" : "h8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "px-8",
                    size: 38,
                    noPadding: true,
                    title: MothersDayBanner_messages.button
                })
            ]
        })
    });
};
/* harmony default export */ const MothersDayBanner_MothersDayBanner = (MothersDayBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/FathersDayBanner/messages.ts
/* harmony default export */ const FathersDayBanner_messages = ({
    title: {
        en: "Shop the dads & grads gift guide"
    },
    button: {
        en: "Shop now"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/FathersDayBanner/FathersDayBanner.tsx









const FathersDayBanner_HEIGHT_DESKTOP = 56;
const FathersDayBanner_HEIGHT_MOBILE = 64;
const bgClassName = "bg-[linear-gradient(90deg,_#d6a77b_0.76%,_#a57142_50.01%,_#ddac7f_100%)]";
const FathersDayBanner = (props)=>{
    const { position } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: bgClassName,
        to: links/* default */.ZP.gifts,
        height: isMobile ? FathersDayBanner_HEIGHT_MOBILE : FathersDayBanner_HEIGHT_DESKTOP,
        trackParams: {
            action: "link",
            content: "Marketing promo",
            contentDetails: "Father’s day",
            link: links/* default */.ZP.gifts,
            placement: "Header",
            position
        },
        "data-testid": "holidayFathersDayBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex h-full items-center justify-center", isMobile ? "gap-40" : "gap-16"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: FathersDayBanner_messages.title,
                    color: "white",
                    style: isMobile ? "h9" : "h8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "px-8",
                    size: 38,
                    noPadding: true,
                    title: FathersDayBanner_messages.button
                })
            ]
        })
    });
};
/* harmony default export */ const FathersDayBanner_FathersDayBanner = (FathersDayBanner);

// EXTERNAL MODULE: ./src/modules/subscription/resubscribe/useResubscribeOffer.tsx
var useResubscribeOffer = __webpack_require__(64881);
// EXTERNAL MODULE: ./src/modules/subscription/prices/index.ts + 1 modules
var prices = __webpack_require__(74447);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/compositions/buttons/ResubscribeButton/ResubscribeButton.tsx
var ResubscribeButton = __webpack_require__(84211);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/ResubscribeBanner/messages.ts
/* harmony default export */ const ResubscribeBanner_messages = ({
    noDiscount: {
        en: "Resubscribe today to access our catalog of over 700 scents."
    },
    discount: {
        en: "Resubscribe and get your next month for {priceWithDiscount}."
    },
    percentOff: {
        en: "Take {eventOffer} your first month back when you resubscribe."
    },
    freeProduct: {
        en: "Resubscribe and get a FREE fragrance in your next order."
    },
    freeCase: {
        en: "Resubscribe and get a FREE case in your next order."
    },
    freeMonth: {
        en: "Resubscribe today, and your next month is FREE."
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/ResubscribeBanner/ResubscribeBanner.tsx











const ResubscribeBanner = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { offer, couponCode, isFetching: isCouponDataFetching, eventOffer } = (0,useResubscribeOffer/* useResubscribeOffer */.W)();
    const { formattedPriceWithDiscount: priceWithDiscount, isFetching: isPricesFetching } = (0,prices/* usePrices */.h)({
        couponCode,
        skip: isCouponDataFetching
    });
    const isFetching = isCouponDataFetching || isPricesFetching;
    let text = offer.startsWith("off") ? ResubscribeBanner_messages.percentOff : ResubscribeBanner_messages[offer];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: "bg-red",
        height: 64,
        loading: isFetching,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: (0,clsx/* default */.Z)("flex  items-center", isMobile ? "justify-between" : "justify-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: {
                        ...text,
                        values: {
                            priceWithDiscount,
                            eventOffer
                        }
                    },
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeButton/* default */.Z, {
                    className: (0,clsx/* default */.Z)("max-w-[128rem] flex-none", isMobile ? "ml-12" : "ml-24"),
                    title: messages/* default */.Z.resubscribe,
                    placement: "Header",
                    size: 38
                })
            ]
        })
    });
};
/* harmony default export */ const ResubscribeBanner_ResubscribeBanner = (ResubscribeBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/DriftSubscriptionTextBanner/messages.ts
/* harmony default export */ const DriftSubscriptionTextBanner_messages = ({
    title: {
        en: "Introducing car scent club by drift"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/DriftSubscriptionTextBanner/DriftSubscriptionTextBanner.tsx







const DriftSubscriptionTextBanner = (param)=>{
    let { className, position = 1 } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: (0,clsx/* default */.Z)(className, "px-8 text-center"),
        title: DriftSubscriptionTextBanner_messages.title,
        to: links/* default */.ZP.driftSubscription,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Drift subscription",
            action: "link",
            link: links/* default */.ZP.driftSubscription,
            position
        },
        html: true,
        "data-testid": "driftSubscriptionTextBanner"
    });
};
/* harmony default export */ const DriftSubscriptionTextBanner_DriftSubscriptionTextBanner = (DriftSubscriptionTextBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BfcmBanner/messages.ts
/* harmony default export */ const BfcmBanner_messages = ({
    title: {
        en: "Our biggest sale of the year [get 20% off]"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BfcmBanner/BfcmBanner.tsx





const BfcmBanner = (param)=>{
    let { position } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        position: position,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full items-center",
            "data-testid": "bfcmBanner",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "flex-1 text-white",
                message: BfcmBanner_messages.title,
                style: "h8"
            })
        })
    });
};
/* harmony default export */ const BfcmBanner_BfcmBanner = (BfcmBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/GiftSubscriptionBanner/messages.ts
/* harmony default export */ const GiftSubscriptionBanner_messages = ({
    title: {
        en: `It's not too late! [gift a subscription]`
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/GiftSubscriptionBanner/GiftSubscriptionBanner.tsx





const GiftSubscriptionBanner = (param)=>{
    let { position } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        position: position,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full items-center",
            "data-testid": "giftSubscriptionBanner",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "flex-1 text-white",
                message: GiftSubscriptionBanner_messages.title,
                style: "h8"
            })
        })
    });
};
/* harmony default export */ const GiftSubscriptionBanner_GiftSubscriptionBanner = (GiftSubscriptionBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/GwpTextBanner/messages.ts
/* harmony default export */ const GwpTextBanner_messages = ({
    title: {
        en: "10 year anniversary sale - take up to 60% off [shop now]"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/GwpTextBanner/GwpTextBanner.tsx






const GwpTextBanner = (param)=>{
    let { position } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: "px-8 text-center",
        title: GwpTextBanner_messages.title,
        to: links/* default */.ZP.shop.theEdit,
        titleStyle: isMobile ? "h9" : "h8",
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Gift With Purchase",
            action: "link",
            link: links/* default */.ZP.shop.theEdit,
            position
        },
        html: true,
        "data-testid": "gwpTextBanner"
    });
};
/* harmony default export */ const GwpTextBanner_GwpTextBanner = (GwpTextBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/Banner.tsx






















const Banner = ()=>{
    const { isFetching, isCardUpdateBannerVisible, isSubscribeBannerVisible, isUndeliverableBannerVisible, isTossInBannerVisible, isPrivateSaleBannerVisible, isUnskipBannerVisible, isCandleSubscriptionBannerVisible, isHolidayBannerVisible, holidayBannerDiscount, isHolidayMothersDayVisible, isHolidayFathersDayVisible, isBlackFridayBannerVisible, isCyberMondayBannerVisible, isResubscribeBannerVisible, isDriftSubscriptionVisible, isDriftSubscriptionHasLaunchPriority, isBfcmBannerVisible, isGiftSubscriptionBannerVisible, isGwpTopBarVisible } = util_useBanner();
    if (isFetching) {
        return null;
    }
    if (isUnskipBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnskipBanner_UnskipBanner, {});
    }
    if (isCardUpdateBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardUpdateBanner_CardUpdateBanner, {});
    }
    if (isUndeliverableBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UndeliverableBanner_UndeliverableBanner, {});
    }
    if (isResubscribeBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeBanner_ResubscribeBanner, {});
    }
    if (isBlackFridayBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackFridayBanner_BlackFridayBanner, {});
    }
    if (isCyberMondayBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CyberMondayBanner_CyberMondayBanner, {});
    }
    if (isSubscribeBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeHeaderBanner/* default */.Z, {});
    }
    if (isDriftSubscriptionVisible && isDriftSubscriptionHasLaunchPriority) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DriftSubscriptionTextBanner_DriftSubscriptionTextBanner, {});
    }
    if (isHolidayBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidaySeasonBanner_HolidaySeasonBanner, {}, "holidayHub");
    }
    const banners = [];
    if (isGwpTopBarVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(GwpTextBanner_GwpTextBanner, {
            position: 0
        }, "gwpBanner"));
    }
    if (isBfcmBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(BfcmBanner_BfcmBanner, {
            position: banners.length + 1
        }, "BfcmBanner"));
    }
    if (isGiftSubscriptionBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionBanner_GiftSubscriptionBanner, {
            position: banners.length + 1
        }, "GiftSubscriptionBanner"));
    }
    if (isDriftSubscriptionVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(DriftSubscriptionTextBanner_DriftSubscriptionTextBanner, {
            position: banners.length + 1
        }, "driftSubscription"));
    }
    if (isHolidayMothersDayVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(MothersDayBanner_MothersDayBanner, {
            position: banners.length + 1
        }, "holidayMothersDay"));
    }
    if (isHolidayFathersDayVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(FathersDayBanner_FathersDayBanner, {
            position: banners.length + 1
        }, "holidayFathersDay"));
    }
    if (holidayBannerDiscount > 0) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(HolidaySeasonBanner_HolidaySeasonBanner, {
            discount: holidayBannerDiscount,
            position: banners.length + 1
        }, "holidayDiscount"));
    }
    if (isCandleSubscriptionBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscriptionBanner_CandleSubscriptionBanner, {
            position: banners.length + 1
        }, "candleSubscription"));
    }
    if (isTossInBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(TossInBanner_TossInBanner, {
            position: banners.length + 1
        }, "tossIn"));
    }
    if (isPrivateSaleBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateSaleBanner_PrivateSaleBanner, {
            position: banners.length + 1
        }, "privateSale"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannersCarousel_BannersCarousel, {
        children: banners
    });
};
/* harmony default export */ const Banner_Banner = (Banner);


/***/ }),

/***/ 49854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Cart_Cart)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(39977);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var modules_cart = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Cart/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "cart"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Cart/Cart.tsx









const Cart = (props)=>{
    const { className } = props;
    const { cart, isFetching } = (0,modules_cart/* useCart */.jD)();
    const intl = (0,useIntl/* default */.Z)();
    const label = intl.formatMessage(messages.label);
    (0,react.useEffect)(()=>{
        void (0,manager/* preloadModal */.My)("cartModal");
    }, []);
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            className: className,
            name: "32/loader",
            color: "white"
        });
    }
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Cart icon click");
        (0,modules_cart/* openCartModal */.kZ)({
            flow: "Cart icon"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (0,clsx/* default */.Z)(className, "relative cursor-pointer text-white"),
        type: "button",
        "aria-label": label,
        "data-testid": "cart",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "32/cart"
            }),
            (cart === null || cart === void 0 ? void 0 : cart.totalCount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute right-0 top-0 flex h-s16 w-s16 items-center justify-center rounded-full border-2 border-black bg-white text-eye3 text-black",
                "data-testid": "cartCount",
                children: cart.totalCount
            })
        ]
    });
};
/* harmony default export */ const Cart_Cart = (Cart);


/***/ }),

/***/ 41612:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ MainHeader_MainHeader)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
;// CONCATENATED MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MainHeader_module = ({"header":"iFJVNB","placeholder":"E0mK8P"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.tsx






const MainHeader = (props)=>{
    const { children, className, size } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-stretch bg-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: MainHeader_module.placeholder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                id: "main-header",
                className: (0,clsx/* default */.Z)(MainHeader_module.header, className, "relative flex flex-1 items-stretch bg-black text-white", isMobile && "z-overlay"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                    className: "flex w-full items-center",
                    size: size,
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ const MainHeader_MainHeader = (MainHeader);


/***/ }),

/***/ 35176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ QueueCounter_QueueCounter)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(45881);
;// CONCATENATED MODULE: ./src/compositions/Header/components/QueueCounter/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "queue"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/QueueCounter/QueueCounter.tsx










const QueueCounter = ()=>{
    var _user_analyticsMetadata;
    const { user, isFetching } = (0,user_user/* useUser */.aF)();
    const pathname = (0,hooks/* usePathname */.jD)();
    const productsCount = (user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.productsInQueueQty) || 0;
    const intl = (0,useIntl/* default */.Z)();
    const label = intl.formatMessage(messages.label);
    (0,react.useEffect)(()=>{
        if (isFetching) {
            return;
        }
        (0,analytics/* track */.j)("Queue icon display", {
            productsInQueueQty: productsCount
        });
    }, [
        isFetching,
        productsCount,
        pathname
    ]);
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "32/loader",
            color: "white"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
        className: "relative cursor-pointer text-white",
        to: links/* default */.ZP.queue,
        "aria-label": label,
        onClick: ()=>{
            (0,analytics/* track */.j)("Queue icon click", {
                productsInQueueQty: productsCount
            });
        },
        "data-testid": "queue",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "32/queue"
            }),
            productsCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute right-0 top-0 flex h-s16 w-s16 items-center justify-center rounded-full border-2 border-black bg-white text-eye3 text-black",
                "data-testid": "cartCount",
                children: productsCount
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "absolute right-0 top-0 rounded-full border border-black",
                name: "16/info",
                color: "red"
            })
        ]
    });
};
/* harmony default export */ const QueueCounter_QueueCounter = (QueueCounter);


/***/ }),

/***/ 86653:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78364);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21380);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78565);
/* harmony import */ var compositions_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1867);






const ReferralNavItem = (param)=>{
    let { textClassName, spanClassName = "", freeFragranceClassName = "", style = null } = param;
    const { stats: { available } } = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useReferralInvites */ .n)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(textClassName),
        tag: "span",
        message: {
            ...compositions_navigation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.newReferral,
            values: {
                available,
                spanClassName,
                freeFragranceClassName
            }
        },
        style: style,
        html: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReferralNavItem);


/***/ }),

/***/ 9667:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Search_Search)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(39977);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Search/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "search"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Search/Search.tsx







const Search = ()=>{
    const intl = (0,useIntl/* default */.Z)();
    const label = intl.formatMessage(messages.label);
    (0,react.useEffect)(()=>{
        void (0,manager/* preloadModal */.My)("searchModal");
    }, []);
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Search input click");
        (0,manager/* openModal */.h7)("searchModal");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "cursor-pointer text-white",
        type: "button",
        "aria-label": label,
        "data-testid": "search",
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "32/search"
        })
    });
};
/* harmony default export */ const Search_Search = (Search);


/***/ }),

/***/ 75715:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94957);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95812);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91746);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40038);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78565);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45881);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34212);









const UserNavWrapper = (param)=>{
    let { children, withRedirect } = param;
    const { isLoggedIn, isFetching } = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)();
    const { currentUrl } = (0,router__WEBPACK_IMPORTED_MODULE_3__/* .useLocationState */ .KJ)();
    if (isFetching) {
        return null;
    }
    if (!isLoggedIn) {
        // ATTN it shouldn't cause any issues with landings, but we can exclude landings if it will
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            to: `${links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.login}${withRedirect ? `?redirect=${encodeURIComponent(currentUrl)}` : ""}`,
            onClick: ()=>{
                (0,analytics__WEBPACK_IMPORTED_MODULE_6__/* .track */ .j)("Login button click");
            },
            "data-testid": "loginButton",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                message: components_inputs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.login,
                style: "t2"
            })
        });
    }
    return children;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserNavWrapper);


/***/ }),

/***/ 57183:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25747);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94957);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63687);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83305);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96934);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80550);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36888);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3268);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40038);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21380);
/* harmony import */ var modules_academy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53526);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29564);
/* harmony import */ var compositions_navigation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1867);
/* harmony import */ var compositions_Header_components_ReferralNavItem_ReferralNavItem__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86653);













const QueueBanner = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName () {
        return "compositions-Header-components-QueueBanner-QueueBanner";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>Promise.all(/* import() | compositions-Header-components-QueueBanner-QueueBanner */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(2912), __webpack_require__.e(8371), __webpack_require__.e(1132), __webpack_require__.e(2230)]).then(__webpack_require__.bind(__webpack_require__, 53233)),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(53233);
        }
        return eval("require.resolve")("compositions/Header/components/QueueBanner/QueueBanner");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "gray-20",
        pw: 100,
        h: 100
    })
});
const useUserNav = ()=>{
    var _subscription_stateOptions, _subscription_plan;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const logout = (0,modules_user__WEBPACK_IMPORTED_MODULE_5__/* .useLogout */ .a)();
    const { hasBillingAddress } = (0,modules_user__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .aF)();
    const { subscription } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_7__/* .useSubscription */ .mU)();
    const isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    const hasNeverSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed;
    // hide upgrade link for users with 3 products per month plan
    const canUpgradeProductsCount = (subscription === null || subscription === void 0 ? void 0 : (_subscription_stateOptions = subscription.stateOptions) === null || _subscription_stateOptions === void 0 ? void 0 : _subscription_stateOptions.canUpgrade) && (subscription === null || subscription === void 0 ? void 0 : (_subscription_plan = subscription.plan) === null || _subscription_plan === void 0 ? void 0 : _subscription_plan.productsPerPeriod) < 3;
    const { stats: { available } } = (0,modules_user__WEBPACK_IMPORTED_MODULE_8__/* .useReferralInvites */ .n)();
    const isReferralItemVisible = Boolean(available);
    const { data } = (0,modules_academy__WEBPACK_IMPORTED_MODULE_9__/* .useAcademyCoursePromo */ .mF)();
    const isScentbirdAcademyCourseVisible = (data === null || data === void 0 ? void 0 : data.status) === "PURCHASED";
    const isQueueNavBannerAbEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z.abTests.queueNavBanner) === "b";
    const isQueueNavBannerEnabled = isQueueNavBannerAbEnabled && isSubscribed;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const data = [
            {
                id: "user-membership",
                title: isQueueNavBannerEnabled && isMobile ? compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.manageDeliveries : compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.membership,
                list: [
                    isQueueNavBannerEnabled && isMobile && {
                        id: "header-queue-banner",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.queue,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.queue,
                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QueueBanner, {})
                    },
                    !isQueueNavBannerEnabled && {
                        id: "user-membership-queue",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.queue,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.queue
                    },
                    {
                        id: "user-membership-orders",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.orderHistory,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.orderHistory
                    },
                    !hasNeverSubscribed && {
                        id: "user-membership-subscription",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.manageSubscription,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.subscriptionStatus
                    },
                    canUpgradeProductsCount && {
                        id: "user-membership-upgrade",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.upgrade,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.upgradeProduct
                    },
                    // TODO handle resubscribe? - added on 07.12.2021 by sonatskiy
                    hasNeverSubscribed && {
                        id: "user-membership-subscribe",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.subscribe,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.subscribe
                    },
                    isScentbirdAcademyCourseVisible && {
                        id: "user-scentbird-academy",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.scentbirdAcademy,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.academy.root,
                        label: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.labels.new
                    }
                ].filter(Boolean)
            },
            {
                id: "user-account",
                title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.account,
                list: [
                    hasBillingAddress && {
                        id: "user-account-billing",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.billingInfo,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.billing
                    },
                    {
                        id: "user-account-shipping",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.shippingInfo,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.shipping
                    },
                    {
                        id: "user-account-personal",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.personalInfo,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.personalInfo
                    },
                    isSubscribed && {
                        id: "user-account-reviews",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.reviews,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.reviews
                    },
                    isReferralItemVisible && {
                        id: "referral-nav-item",
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.invite,
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.referralProgram,
                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_Header_components_ReferralNavItem_ReferralNavItem__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            spanClassName: `text-white align-text-bottom ${isMobile ? "bg-gold-70" : "bg-gold-50"}`,
                            freeFragranceClassName: isMobile ? "text-gold-70" : "text-gold-30"
                        })
                    },
                    {
                        id: "user-account-help",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.support,
                        toTab: "https://scentbird.zendesk.com/hc/en-us"
                    },
                    {
                        id: "user-account-logoff",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.logoff,
                        href: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.logoff,
                        onClick: async (event)=>{
                            event.preventDefault();
                            try {
                                await logout();
                                window.location.reload();
                            } catch (error) {
                                (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* .processError */ .wY)(error);
                            }
                        }
                    }
                ].filter(Boolean)
            }
        ];
        return data.filter(Boolean);
    }, [
        canUpgradeProductsCount,
        hasBillingAddress,
        hasNeverSubscribed,
        isReferralItemVisible,
        isSubscribed,
        isScentbirdAcademyCourseVisible,
        logout,
        isMobile
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUserNav);


/***/ }),

/***/ 26458:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var modules_brands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83474);
/* harmony import */ var compositions_banners_BannerBase_BannerBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61835);





// TODO: Merge with DynamicNavigationBanner after strapi banners refactoring — added on 17-04-2023 by algeas
const StrapiWSTONavigationBanner = (props)=>{
    var _strapiWSTONavigationData_banners;
    const { placement, onClick, "data-testid": dataTestId = "brandsBanner" } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const strapiWSTONavigationData = (0,modules_brands__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const strapiWSTONavigationBannerData = strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners === void 0 ? void 0 : _strapiWSTONavigationData_banners[placement];
    if (!strapiWSTONavigationBannerData) {
        return null;
    }
    const { to, name } = strapiWSTONavigationBannerData;
    const { background } = strapiWSTONavigationBannerData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_banners_BannerBase_BannerBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        to: to,
        bgImage: isMobile ? background === null || background === void 0 ? void 0 : background.mobile : background === null || background === void 0 ? void 0 : background.desktop,
        content: "Featured brand",
        "data-testid": dataTestId,
        onClick: onClick,
        sizes: "560px",
        trackParams: {
            productBrand: name
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StrapiWSTONavigationBanner);


/***/ })

}]);